import { credentialService } from '../../services/CredentialService';
const state = {
    loading: false,
    error: null,
};
const mutations = {
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
};
const actions = {
    async connectStore({ commit }, { platform, data }) {
        try {
            commit('SET_LOADING', true);
            commit('SET_ERROR', null);
            let response;
            if (platform === 'shopify') {
                response = await credentialService.shopifyStore(data);
            }
            else if (platform === 'bigcommerce') {
                response = await credentialService.bigCommerceStore(data);
            }
            else if (platform === 'walmart') {
                response = await credentialService.walmartStore(data);
            }
            return response;
        }
        catch (error) {
            commit('SET_ERROR', error.message || 'Failed to connect store');
            throw error;
        }
        finally {
            commit('SET_LOADING', false);
        }
    },
};
const getters = {
    loading: (state) => state.loading,
    error: (state) => state.error,
};
const credential = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
export default credential;
